
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { singleton, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";

function iconSvg(size, strokeWidth, children) {
    return reactElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: (((((0 + " ") + 0) + " ") + 24) + " ") + 24,
        fill: "none",
        stroke: "currentColor",
        strokeWidth: strokeWidth,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: reactApi.Children.toArray(Array.from(children)),
    });
}

export function icon(size, children) {
    return iconSvg(size, 1.6, children);
}

export function laptop(size) {
    return icon(size, ofArray([reactElement("rect", {
        x: 3,
        y: 5,
        width: 18,
        height: 12,
        rx: 2,
    }), reactElement("path", {
        d: "M2 20h20",
    })]));
}

export function wrench(size) {
    return icon(size, singleton(reactElement("path", {
        d: "M14.7 6.3a4 4 0 0 0-5 5L3 18l3 3 6.7-6.7a4 4 0 0 0 5-5l-2.3 2.3-2.4-2.4 2.3-2.3a4 4 0 0 0-.6-.6Z",
    })));
}

export function excavator(size) {
    return icon(size, ofArray([reactElement("path", {
        d: "M3 18h14a2 2 0 0 0 2-2v-1h2",
    }), reactElement("circle", {
        cx: 7,
        cy: 18,
        r: 2,
    }), reactElement("circle", {
        cx: 14,
        cy: 18,
        r: 2,
    }), reactElement("path", {
        d: "M5 15h9v-4H7l-2 4Z",
    }), reactElement("path", {
        d: "M14 11l4-5 3 2",
    })]));
}

export function truck(size) {
    return icon(size, ofArray([reactElement("path", {
        d: "M2 7h11v10H2z",
    }), reactElement("path", {
        d: "M13 10h5l3 3v4h-8",
    }), reactElement("circle", {
        cx: 6,
        cy: 18,
        r: 2,
    }), reactElement("circle", {
        cx: 17,
        cy: 18,
        r: 2,
    })]));
}

export function gauge(size) {
    return icon(size, ofArray([reactElement("path", {
        d: "M3 13a9 9 0 0 1 18 0",
    }), reactElement("path", {
        d: "M12 13l4-3",
    }), reactElement("circle", {
        cx: 12,
        cy: 13,
        r: 1,
    })]));
}

export function medical(size) {
    return icon(size, ofArray([reactElement("path", {
        d: "M12 3v18M3 12h18",
    }), reactElement("rect", {
        x: 5,
        y: 5,
        width: 14,
        height: 14,
        rx: 2,
    })]));
}

export function plus(size) {
    return icon(size, ofArray([reactElement("circle", {
        cx: 12,
        cy: 12,
        r: 9,
    }), reactElement("path", {
        d: "M12 8v8M8 12h8",
    })]));
}

export function grid(size) {
    return icon(size, ofArray([reactElement("rect", {
        x: 3,
        y: 3,
        width: 7,
        height: 7,
        rx: 1,
    }), reactElement("rect", {
        x: 14,
        y: 3,
        width: 7,
        height: 7,
        rx: 1,
    }), reactElement("rect", {
        x: 3,
        y: 14,
        width: 7,
        height: 7,
        rx: 1,
    }), reactElement("rect", {
        x: 14,
        y: 14,
        width: 7,
        height: 7,
        rx: 1,
    })]));
}

export function loss(size) {
    return icon(size, ofArray([reactElement("circle", {
        cx: 11,
        cy: 11,
        r: 7,
    }), reactElement("path", {
        d: "m20 20-3.5-3.5",
    }), reactElement("path", {
        d: "M8 11h6",
    })]));
}

export function checkList(size) {
    return icon(size, ofArray([reactElement("path", {
        d: "M9 5h11",
    }), reactElement("path", {
        d: "M9 12h11",
    }), reactElement("path", {
        d: "M9 19h11",
    }), reactElement("path", {
        d: "m3 5 2 2 3-3",
    }), reactElement("path", {
        d: "m3 12 2 2 3-3",
    }), reactElement("path", {
        d: "m3 19 2 2 3-3",
    })]));
}

export function coin(size) {
    return icon(size, ofArray([reactElement("circle", {
        cx: 12,
        cy: 12,
        r: 9,
    }), reactElement("path", {
        d: "M15 9h-4a2 2 0 0 0 0 4h2a2 2 0 0 1 0 4H9",
    }), reactElement("path", {
        d: "M12 7v2M12 15v2",
    })]));
}

export function flow(size) {
    return icon(size, ofArray([reactElement("rect", {
        x: 3,
        y: 4,
        width: 6,
        height: 6,
        rx: 1,
    }), reactElement("rect", {
        x: 15,
        y: 4,
        width: 6,
        height: 6,
        rx: 1,
    }), reactElement("rect", {
        x: 9,
        y: 14,
        width: 6,
        height: 6,
        rx: 1,
    }), reactElement("path", {
        d: "M6 10v2h12v-2",
    }), reactElement("path", {
        d: "M12 12v2",
    })]));
}

export function chat(size) {
    return icon(size, singleton(reactElement("path", {
        d: "M4 5h13a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-6l-4 3v-3H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Z",
    })));
}

export function check(size) {
    return iconSvg(size, 2.2, singleton(reactElement("path", {
        d: "m5 12 5 5 9-11",
    })));
}

export function arrowRight(size) {
    return icon(size, ofArray([reactElement("path", {
        d: "M5 12h14",
    }), reactElement("path", {
        d: "m13 6 6 6-6 6",
    })]));
}

export function arrowLeft(size) {
    return icon(size, ofArray([reactElement("path", {
        d: "M19 12H5",
    }), reactElement("path", {
        d: "m11 6-6 6 6 6",
    })]));
}

export function sparkle(size) {
    return icon(size, singleton(reactElement("path", {
        d: "M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5 18 18M6 18l2.5-2.5M15.5 8.5 18 6",
    })));
}

